import styled from 'styled-components';

export const SuccessWrapper = styled.div`
  text-align: center;
`;

export const SuccessTitle = styled.h2`
  margin-top: 0;
`;
